import ReceiveSharingIntentModule from "./ReceiveSharingIntent";

export default new ReceiveSharingIntentModule();